import { getInstance as getBootstrap } from 'utils/bootstrap';

import {
    EMBED_TYPE_ZOOM,
    EMBED_TYPE_VIMEO,
    EMBED_TYPE_RAW,
    EMBED_TYPE_INTROVOKE,
    EMBED_TYPE_GOLDCAST,
} from 'common/constants/virtualEvent';

const { virtualEventZoom, virtualEventVimeo, virtualEventIntrovoke } = getBootstrap().get('flags') || {
    virtualEventZoom: false,
    virtualEventVimeo: false,
    virtualEventIntrovoke: false,
};

const goldcastVirtualEvent = getBootstrap().get('goldcastVirtualEvent');
const isGoldcastAvailable = Boolean(goldcastVirtualEvent?.gcEventId && goldcastVirtualEvent?.gcBroadcastId);

export const EMBED_CONFIG_VERSION_1_0_0 = '1.0.0';
export const EMBED_CONFIG_VERSION_2_0_0 = '2.0.0';

export const EMBED_CONFIG_VERSION = EMBED_CONFIG_VERSION_2_0_0;

const embedTypes = [
    isGoldcastAvailable && { type: EMBED_TYPE_GOLDCAST, label: 'Cvent | Splash Studio' },
    virtualEventIntrovoke && { type: EMBED_TYPE_INTROVOKE, label: 'Splash Studio' },
    virtualEventZoom && { type: EMBED_TYPE_ZOOM, label: 'Zoom' },
    virtualEventVimeo && { type: EMBED_TYPE_VIMEO, label: 'Vimeo' },
    { type: EMBED_TYPE_RAW, label: 'Custom Embed' },
].filter(Boolean);

export const EMBED_TYPES = embedTypes.map((embedType) => embedType.type);
export const EMBED_TYPES_LABELS = embedTypes.reduce(
    (prev, current) => ({ ...prev, [current.type]: current.label }),
    {},
);
export const LOCKED_ALT_EMBEDS = [EMBED_TYPE_ZOOM, EMBED_TYPE_INTROVOKE, EMBED_TYPE_GOLDCAST];
